module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Custom fields"},"et":{"title":"Custom fields"},"ru":{"title":"Custom fields"}}')
  delete Component.options._Ctor
}
